import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const analyticsAdmissionOffice: ApiFunc<`${typeof API.ANALYTICS_ADMISSION_OFFICE}`, 'get'> = data =>
  instance.get(API.ANALYTICS_ADMISSION_OFFICE, {
    params: data,
  })
